import { Button, Stack, Typography, useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router";
import { ROUTES } from "../../../routes";
import { useClientPortalConfigContext } from "../../../context";

const CalendarIcon = () => {
    const theme = useTheme();

    return (
        <svg
            width="157"
            height="120"
            viewBox="0 0 157 120"
            fill={theme.palette.primary.main}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M90.7617 90.1157C126.982 75.5086 150.708 49.7421 143.755 32.5645C136.802 15.3869 101.803 13.303 65.5826 27.9101C29.3624 42.5171 5.63652 68.2836 12.5895 85.4612C19.5425 102.639 54.5414 104.723 90.7617 90.1157Z"
                fill={theme.palette.background.default}
            />
            <path
                d="M99.4894 70.455L104.793 75.7583L112.748 67.8033L110.626 65.682L104.793 71.5157L101.611 68.3337L99.4894 70.455Z"
                fill={theme.palette.primary.main}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M82.28 28.665H94.605C102.05 28.665 108.105 34.72 108.105 42.165V56.6498C114.863 57.6438 120.05 63.4661 120.05 70.5C120.05 77.5354 114.86 83.3588 108.1 84.3509C107.914 91.6343 101.933 97.5 94.605 97.5H41.5C34.055 97.5 28 91.445 28 84V55.7H31V84C31 89.79 35.71 94.5 41.5 94.5H94.605C100.238 94.5 104.849 90.0416 105.095 84.4679C97.8082 83.9769 92.05 77.9109 92.05 70.5C92.05 63.0856 97.8137 57.0174 105.105 56.5314V42.165C105.105 36.375 100.395 31.665 94.605 31.665H82.28V37.83H79.28V31.665H56.82V37.83H53.82V31.665H39.985C35.03 31.665 31 35.695 31 40.65C31 46.22 35.32 49.3 44.21 50.065C48.995 50.475 57.845 50.98 67.645 51.46C75.95 46.465 85.745 42.935 92.015 42.935C97.31 42.935 100.085 46.085 100.085 49.195C100.085 50.9 99.265 52.535 97.84 53.685C96.34 54.895 94.26 55.53 91.825 55.53H91.765C84.28 55.235 76.045 54.875 68.38 54.505C61.435 58.84 55.88 64.09 55.28 68.465L52.31 68.055C52.945 63.445 57.435 58.515 63.385 54.255C55.23 53.84 48.145 53.415 43.955 53.055C36.675 52.43 28 49.77 28 40.65C28 34.04 33.375 28.665 39.985 28.665H53.82V22.5H56.82V28.665H79.28V22.5H82.28V28.665ZM97.085 49.2C97.085 47.63 95.5 45.94 92.015 45.94C86.995 45.94 79.89 48.305 73.26 51.735C79.57 52.03 86.025 52.305 91.855 52.535C95.45 52.525 97.085 50.77 97.085 49.2ZM106.05 81.5C112.125 81.5 117.05 76.5751 117.05 70.5C117.05 64.4249 112.125 59.5 106.05 59.5C99.9749 59.5 95.05 64.4249 95.05 70.5C95.05 76.5751 99.9749 81.5 106.05 81.5Z"
                fill={theme.palette.primary.main}
            />
        </svg>
    );
};

export default function NoAppointments() {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const { clientPortalGuid, clientPortalConfig } = useClientPortalConfigContext();

    return (
        <Stack alignItems="center" direction={isMobile ? "column" : "row"} data-test-id="section_no_appointments">
            <CalendarIcon />

            <Stack direction="column" spacing={2} justifyContent="center">
                <Typography
                    variant="h6"
                    sx={{
                        textAlign: isMobile ? "center" : "left",
                    }}
                >
                    You don&apos;t have any appointments yet
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        textAlign: isMobile ? "center" : "left",
                    }}
                >
                    When you have appointments, they&apos;ll appear here for easy access. Stay organized and keep track
                    of everything in one place.
                </Typography>
                {clientPortalConfig.featureAccess?.canBookAppointments && (
                    <Stack direction="row" justifyContent={isMobile ? "center" : "flex-start"}>
                        <Button
                            variant="outlined"
                            size="extraSmall"
                            type="button"
                            onClick={() =>
                                void navigate(`/clientportal/${clientPortalGuid}/${ROUTES.APPOINTMENT_BOOKING.urlPath}`)
                            }
                            data-test-id="book_appointment_button"
                        >
                            Book an Appointment
                        </Button>
                    </Stack>
                )}
            </Stack>
        </Stack>
    );
}
